namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;

    export interface IDataTableService {
        delete(dataTable: pms.DataTable): angular.IPromise<boolean>;
        get(): angular.IPromise<pms.DataTable[]>;
		getHistory(id: string, spinner?: string): angular.IPromise<pms.DataTable[]>;
        save(dataTable: pms.DataTable): angular.IPromise<pms.DataTable>;
    }

    @Service('app', 'dataTableService')
	@Inject('$q', 'apiService', 'serverConstants', 'storageService')
    export class DataTableService implements IDataTableService {
        constructor(
            private $q: angular.IQService,
            private apiService: IApiService,
			private serverConstants: pmi.IServerConstants,
            private storageService: IStorageService
        ) { }

        delete(dataTable: pms.DataTable): angular.IPromise<boolean> {
            const endpoint = `/datatable/${dataTable.id}`;

            return this.apiService.deleteItem(endpoint).then((response: boolean) => {
                return response;
            });
        }

        get(): angular.IPromise<pms.DataTable[]> {
            const endpoint = `/datatable`;

			let timestamp: Date = new Date( this.storageService.getItem<Date>(pm.StorageType.Local, `dataTable-list-timestamp`));
			let dataTables: pms.DataTable[] = timestamp >= this.serverConstants.tsDataTable ? this.storageService.getItem<pms.DataTable[]>(pm.StorageType.Local, `dataTable-list`) : null;

            const promise = dataTables ?
                this.$q.when(dataTables) :
                this.apiService.getItem<pms.DataTable[]>(endpoint);

            return promise.then((response: pms.IDataTable[]) => {
                const temp: pms.DataTable[] = [];

                for (const dataTable of response) {
                    temp.push(new pms.DataTable(dataTable));
                }

				this.storageService.saveItem<pms.DataTable[]>(pm.StorageType.Local, `dataTable-list`, temp);
				this.storageService.saveItem<Date>(pm.StorageType.Local, `dataTable-list-timestamp`, this.serverConstants.tsDataTable);

                return temp;
            });
        }

		getHistory(id: string, spinner: string = null): angular.IPromise<pms.DataTable[]> {
			const endpoint = `/datatablehistory/${id}`;

			return this.apiService.getItem<pms.DataTable[]>(endpoint, spinner).then((response: pms.DataTable[]) => {
				const dataTables: pms.DataTable[] = [];

				for (const dataTable of response) {
					dataTables.push(new pms.DataTable(dataTable));
				}

				return _.orderBy(dataTables, ['createdOn'], ['desc']);
			});
		}

        save(dataTable: pms.DataTable): angular.IPromise<pms.DataTable> {
            const endpoint = `/datatable`;

            return this.apiService.saveItem<pms.DataTable, pms.DataTable>(endpoint, dataTable).then((response: pms.IDataTable) => {
                return new pms.DataTable(response);
            });
        }
    }
}